import { db } from "../../firebase";

export const Referral = db.collection('referrals')